<template>
  <div>
    <div class="row">
      <div class="col-12">
        <div class="beast-organization-list">
          <ul v-if="organizations.count">
            <li class="beast-organization-info" :key="org.id" v-for="org in organizations.data">
              <div class="row">
                <div class="col-8 beast-organization-name">
                  <router-link :to="`/organization/${org.slug}`">
                    {{org.slug}}
                  </router-link>
                </div>
              </div>
              <div class="row">
                <div class="col-12 beast-user-info">
                  Owner:
                  <router-link :to="`/profile/${org.Owner.username}`" class="beast-user-link">
                    {{org.Owner.firstName}} {{org.Owner.lastName}}
                  </router-link>
                </div>
              </div>
            </li>
          </ul>
          <ul v-else>
            <li class="beast-organization-none">
              This user isn't member of any organization yet.
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <pagination :current="organizations.page"
                    :pages="organizations.pages"
                    @pageChange="fetchData"/>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "../utils/Pagination.vue";

export default {
  name: "BeastOrganizationsList",
  components: { Pagination },
  props: {
    url: {
      type: String,
      default: "/organizations"
    },
    page: {
      type: Number,
      default: 1
    },
    size: {
      type: Number,
      default: 10
    }
  },

  watch: {
    async url() {
      await this.fetchData(1);
    }
  },

  methods: {
    fetchData(page) {
      this._searchRepository(page);
    },

    async _searchRepository(page = 1) {
      if (this.url === "") {
        return;
      }
      const queryParams = {
        params: {
          size: this.size,
          page
        }
      };

      const response = await this.axios.get(this.url, queryParams);
      this.organizations = response.data;
    },
  },

  data() {
    return {
      query: "",
      organizations: {
        data: [],
        count: 0,
        page: 0,
        pages: 0,
        size: 0
      },
    };
  },

  async beforeMount() {
    await this._searchRepository(this.page);
  }
};
</script>

<style scoped lang="scss">
  .beast-organization-list {
    padding: 5px 15px;
    ul {
      list-style: none;
      padding: 0;
      li {
        &.beast-organization-info, &.beast-organization-none {
          display: block;
          margin-top: 15px;
          padding-top: 15px;
          border-top: 1px solid #ededed;

          &:first-child {
            border-top: none;
            margin-top: 0px;
            padding-top: 0px;
          }
        }
      }
    }

    .beast-organization-name {
      font-weight: bold;
      font-size: 15pt;
      a {
        text-decoration: none;

        &:hover {
          color: $beast-dark-gray;
        }
      }
    }

    .beast-user-info {
      margin-top: 8px;

      .beast-user-text {
        color: #898989;
        font-style: italic;
      }

      .beast-user-link {
        font-weight: bold;
        color: $beast-dark-gray;
        text-decoration: none;
        font-style: normal;

        &:hover {
          color: $beast-green;
        }
      }
    }

  }
</style>
